import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchCategories = createAsyncThunk(
    'config/fetchCategories',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/categories`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);


        })
    }
)

export const fetchTags = createAsyncThunk(
    'config/fetchTags',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/tags`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);


        })
    }
)

export const addBannerSlide = createAsyncThunk(
    'config/addBannerSlide',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/update-component/banner-slider`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

export const deleteBannerSlide = createAsyncThunk(
    'config/deleteBannerSlide',
    async (params) => {
        return axios({
            method: 'delete',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/update-component/banner-slider`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: params
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

export const updateBannerSlide = createAsyncThunk(
    'config/updateBannerSlide',
    async (payload) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/update-component/banner-slider`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)